import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import Header from "./components/Header";
import Body from "./components/Body/Body";
import { CookieSetting } from "cookiesetting-component";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import { useHyperlink } from "./contexts/HyperlinkProvider";

const Footer = lazy(() => import("./components/Footer/Footer.js"));
const Rates = lazy(() => import("./components/Rates/Rates.js"));
const Joaquin = lazy(() => import("./components/Homebuyingfeature/Homebuyingfeature.js"));
const Assistance = lazy(() =>
  import("./components/ExploreAssistance/Assistance.js")
);
const Market = lazy(() => import("./components/Market/Market.js"));
export default function App() {
  const appVersion = appversion.version;
  const [angelAiLink, setAngelAiLink] = useState('');
  const [angelComLink, setAngelComLink] = useState('');
  const [sunwestMortgageLink, setSunWestMortgageLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();
 
 
  useEffect(() => {
    const processContent = async () => {
      
      const sunwestMortgageLink = await getHyperLink('websites', 'swmc',1);
      const swLink = await getHyperLink('websites', 'swmc', 0);
      const aiLink = await getHyperLink('websites', 'angelai', 0);
      const aiComLink = await getHyperLink('websites','angelai',1);
      const cellLink = await getHyperLink('websites', 'celligence', 1);
      const celliLlcLink = await getHyperLink('websites', 'celligence', 0);
      const pavan = await getHyperLink('profiles', 'pavan', 0);
  
      setSunWestMortgageLink(sunwestMortgageLink || 'Sun West Mortgage Company, Inc.');
      setAngelAiLink(aiLink || 'AngelAi');
      setAngelComLink(aiComLink || 'AngelAi.com');
      setSunWestLink(swLink || 'Sun West Mortgage Company, Inc.');
      setCelligenceLink(cellLink || 'Celligence');
      setCelligenceLlcLink(celliLlcLink || 'Celligence LLC');
      setPavanLink(pavan || 'Pavan Agarwal');
  
 
 
    };
    processContent();
  }, [getHyperLink])
 
 
  return (
    <CacheBuster
      currentVersion={appVersion}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      <div className="bodyContainer">
        <Header fetchpriority="high" />
        <>
          <Body sunwestLink={sunwestLink}/>
          <Suspense fallback={<div />}>
            <Market sunwestLink={sunwestLink} sunwestMortgageLink={sunwestMortgageLink}/>
          </Suspense>
          <Suspense fallback={<div />}>
            <Assistance />
          </Suspense>
          <Suspense fallback={<div />}>
            <Rates sunwestLink={sunwestLink}/>
          </Suspense>
          <Suspense fallback={<div />}>
            <Joaquin sunwestLink={sunwestLink} angelAiLink={angelAiLink}/>
          </Suspense>
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
          <CookieSetting 
            privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
            configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
            analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
        </>
      </div>
    </CacheBuster>
  );
}
